import AppLayout from '@/layout/AppLayout.vue'

const LawEnforcement = () => import('@/view/lawEnforcement/LawEnforcement.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/lawEnforcement',
        component: LawEnforcement,
      },
    ]
  },
]
const components = {}

export default {
  routes,
  components,
}
